export default __webpack_public_path__ + "navigation-overview-header-image-1200-56703df31f90ec37d40c8e095d520549.webp";